// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"612":"b9a1371d","703":"8b490013","787":"bf125a00"}[chunkId] + ".chunk.js";
};